import classNames from 'classnames';
import React, { use, useRef } from 'react';

import RedesignLinkDropdownCta from 'src/components/common/redesign-link-dropdown-cta';
import type { HeaderButtonProps } from 'src/components/layout/redesign/header-mobile/header-button';
import HeaderButton from 'src/components/layout/redesign/header-mobile/header-button';
import { SiteContext } from 'src/context/site-context';

import * as styles from './header-action.module.scss';

export type HeaderActionsProps = {
  primaryButton?: HeaderButtonProps;
  secondaryButton?: HeaderButtonProps;
  onHover: () => void;
  linkDropdownCta?: Queries.LinkDropdownCta;
};

const HeaderActions = ({
  primaryButton,
  secondaryButton,
  onHover,
  linkDropdownCta,
}: HeaderActionsProps) => {
  const { isGlobalPage } = use(SiteContext);
  const headerButtonRef = useRef<HTMLAnchorElement | null>(null);
  const redesignLinkDropdownCtaRef = useRef<HTMLDivElement | null>(null);

  return (
    <div
      className={classNames(styles.actions, isGlobalPage && styles.actionsGlobal)}
      onPointerOver={onHover}
    >
      {secondaryButton && (
        <HeaderButton {...secondaryButton} className={styles.noWrap} ref={headerButtonRef} />
      )}
      {primaryButton && !linkDropdownCta?.enabled && (
        <HeaderButton {...primaryButton} className={styles.noWrap} />
      )}
      {linkDropdownCta?.enabled && (
        <RedesignLinkDropdownCta
          links={linkDropdownCta.dropdownOptions}
          ref={redesignLinkDropdownCtaRef}
          {...linkDropdownCta}
        />
      )}
    </div>
  );
};

export { HeaderActions };
